import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { LinkGithubAppInput } from '~/schemas/gitIntegrationsSchemas';
import { githubAppService } from '~/services/userAPI';
import { getTaskPackageQueryKey } from '../activity';

export enum LinkGithubSourceMutationErrors {
  SET_GITHUB_REPO_ERROR = 'SET_GITHUB_REPO_ERROR',
}

export const useLinkGithubSourceMutation = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation(
    async (input: LinkGithubAppInput) => {
      const response = await githubAppService.setGithubAppRepo({
        ...input,
      });

      if (!response.ok) {
        dispatch({
          type: LinkGithubSourceMutationErrors.SET_GITHUB_REPO_ERROR,
          error: response.data as string,
        });
        throw new Error(response.problem);
      }

      return response.data;
    },
    {
      onSuccess: (_, { robotId }) => {
        queryClient.invalidateQueries(getTaskPackageQueryKey(robotId));
      },
    },
  );
};
